import React from 'react';
import Markdown from 'core/markdown';
import { FormField } from 'ui/formField';

// type Props = {
//   /** The offset height of the markdown input. */
//   offsetHeight: number,
//   /** The scroll height of the markdown input. */
//   scrollHeight: number,
//   /** The offset top position of the markdown input. */
//   scrollTop: number,
//   /** The text to convert to markdown. */
//   text: string,
// };

export default class MarkdownPreviewPanel extends React.Component {
  static defaultProps = {
    offsetHeight: 1,
    scrollHeight: 1,
    scrollTop: 0,
    text: '',
  };

  state = {
    ref: null,
  };

  handleRef = (ref) => {
    this.setState({ ref });
  };

  render() {
    const { offsetHeight, scrollHeight, scrollTop, text } = this.props;
    const { ref } = this.state;
    if (ref) {
      const scrollDistance = scrollHeight - offsetHeight;
      const scrollInputDistance = ref.scrollHeight - ref.offsetHeight;
      const scrollFraction = scrollTop / scrollDistance;
      ref.scrollTop = scrollFraction * scrollInputDistance;
    }
    return (
      <FormField labelText="Preview">
        <div ref={this.handleRef}>
          <Markdown source={text} />
        </div>
      </FormField>
    );
  }
}
